export default __webpack_public_path__ + "static/media/22-picnic-2021.1696aec6.jpeg";